/** Flatten nested locale JSON into dot-notation keys (j-net pattern). */
export function flattenTranslations(
  input: unknown,
  prefix = '',
  out: Record<string, string> = {},
): Record<string, string> {
  if (!input || typeof input !== 'object') return out;
  for (const [k, v] of Object.entries(input as Record<string, unknown>)) {
    const key = prefix ? `${prefix}.${k}` : k;
    if (typeof v === 'string') out[key] = v;
    else if (v && typeof v === 'object' && !Array.isArray(v)) {
      flattenTranslations(v, key, out);
    }
  }
  return out;
}
